export const WIDGET_LIMIT = 10
export const PAGE_LIMIT = 50
